import React from 'react';
import DayJS from 'react-dayjs';

const DateFormatted = ({date}) => {
  return <DayJS format={'DD MMMM YYYY HH:mm'} date={date}></DayJS>;
};

export default DateFormatted;
